import React, {FC} from "react";
import {Service} from "../redux/types";
import {useChangeServicePosition, useUpdateServiceStatus} from "../redux/services.hook";
import {useHistory} from "react-router-dom";
import {useEditorLocation} from "../../../editor/editor.hook";
import {CircularProgress, Grid, IconButton, Paper, Typography} from "@material-ui/core";
import {EditServiceForm} from "../form/EditServiceForm";
import {ArrowDownward, ArrowUpward, Edit as EditIcon} from "@material-ui/icons";
import {StatusIcon} from "../../../sharedComponents/StatusIcon";

export const ServiceListItem: FC<{ service: Service, isLast: boolean }> = ({service, isLast}) => {
    const {updateServiceStatus} = useUpdateServiceStatus();
    const history = useHistory();
    const {mode, reference} = useEditorLocation();
    const [isLoading, setIsLoading] = React.useState(false);

    const {changeServicePosition} = useChangeServicePosition();

    const doUpdateServiceStatus = (id: string, active: boolean) => {
        setIsLoading(true);
        return updateServiceStatus(id, active)
            .catch(() => {
            })
            .finally(() => setIsLoading(false))
    }

    return (
        <Grid item xs={3}>
            <Paper style={{display: 'flex', justifyContent: 'space-between', padding: 16, height: 96}}>
                <Typography color="textSecondary"><b>{service.position + 1}</b></Typography>
                {
                    mode === 'edit' && reference === service.id
                        ? <EditServiceForm id={service.id}/>
                        : (
                            <div style={{width: 180}}>
                                <Typography>{service.name}</Typography>
                                <Typography variant="subtitle1" color="textSecondary">{service.subtitle}</Typography>
                            </div>
                        )
                }
                {isLoading
                    ? <CircularProgress color="secondary" size={"2em"}/>
                    : <React.Fragment>
                        {
                            reference !== service.id && (
                                <div style={{display: "flex", flexDirection: "column"}}>
                                    <div>
                                        <IconButton
                                            size="small"
                                            edge="end"
                                            disabled={service.position === 0}
                                            onClick={() => changeServicePosition(service.id, "decrement")}
                                        >
                                            <ArrowUpward/>
                                        </IconButton>
                                        <IconButton
                                            size="small"
                                            edge="end"
                                            disabled={isLast}
                                            onClick={() => changeServicePosition(service.id, "increment")}
                                        >
                                            <ArrowDownward/>
                                        </IconButton>
                                    </div>
                                    <div>
                                        <IconButton
                                            size="small"
                                            edge="end"
                                            onClick={() => history.replace('/admin/services?mode=edit#' + service.id)}
                                        >
                                            <EditIcon/>
                                        </IconButton>
                                        <IconButton
                                            size="small"
                                            edge="end"
                                            title={service.active ? 'Aktiv (click um zu deaktivieren)' : 'Inaktiv (click um zu aktivieren)'}
                                            onClick={() => doUpdateServiceStatus(service.id, !service.active)}
                                        >
                                            <StatusIcon active={service.active}/>
                                        </IconButton>
                                    </div>
                                </div>
                            )
                        }
                    </React.Fragment>
                }
            </Paper>
        </Grid>
    )
}
